// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "./Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as View from "../../primitives/View.res.js";
import * as Stack from "./Stack.res.js";
import * as Title from "../typography/Title.res.js";
import * as React from "react";
import * as Button from "../actions/Button.res.js";
import * as Inline from "./Inline.res.js";
import * as Spinner from "../feedback-indicators/Spinner.res.js";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as Illustration from "../images-and-icons/Illustration.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let text = I18n.t("N/A");
function Placeholder$NA(props) {
  return JsxRuntime.jsx(TextStyle.make, {
    children: View.t(text),
    variation: "placeholder",
    size: "xsmall",
    italic: true
  });
}
let NA = {
  text: text,
  make: Placeholder$NA
};
let text$1 = I18n.t("N/C");
function Placeholder$NC(props) {
  return JsxRuntime.jsx(TextStyle.make, {
    children: View.t(text$1),
    variation: "placeholder",
    size: "xsmall",
    italic: true
  });
}
let NC = {
  text: text$1,
  make: Placeholder$NC
};
let text$2 = "—";
function Placeholder$Empty(props) {
  return JsxRuntime.jsx(TextStyle.make, {
    children: View.t(text$2),
    variation: "placeholder",
    size: "xsmall"
  });
}
let Empty = {
  text: text$2,
  make: Placeholder$Empty
};
function illustrationStyle(compact) {
  return {
    alignItems: "center",
    width: compact ? "140px" : "auto"
  };
}
function statusToText(status) {
  if (typeof status === "object") {
    return {
      title: status.title,
      text: status.message
    };
  }
  switch (status) {
    case "Loading":
      return {
        title: I18n.t("Loading..."),
        text: I18n.t("Please wait.")
      };
    case "NoDataAvailable":
      return {
        title: I18n.t("No data available"),
        text: ""
      };
    case "Error":
      return {
        title: I18n.t("Loading issue"),
        text: ""
      };
  }
}
function Placeholder(props) {
  let childComponent = props.childComponent;
  let __compact = props.compact;
  let customText = props.customText;
  let status = props.status;
  let compact = __compact !== undefined ? __compact : false;
  let newrecord = {
    ...{
      className: "flex-x98rzlu minHeight-xwiaikj minWidth-xfw766j",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/Placeholder.res.js:66"
    }
  };
  let newrecord$1 = {
    ...{
      className: "transform-x11lhmoz alignItems-x6s0dn4 display-x78zum5 flexDirection-xdt5ytf left-x1nrll8i position-x10l6tqk top-x9cnl97",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/Placeholder.res.js:71"
    }
  };
  let tmp;
  if (typeof status !== "object") {
    switch (status) {
      case "Loading":
        tmp = JsxRuntime.jsx(Spinner.make, {
          size: compact ? 25 : 30
        });
        break;
      case "NoDataAvailable":
        tmp = JsxRuntime.jsx(Illustration.make, {
          element: Illustration.emptyData
        });
        break;
      case "Error":
        tmp = JsxRuntime.jsx(Illustration.make, {
          element: Illustration.error
        });
        break;
    }
  } else {
    let element = status.illustration;
    tmp = element !== undefined ? JsxRuntime.jsx(Illustration.make, {
      element: Primitive_option.valFromOption(element)
    }) : JsxRuntime.jsx(Illustration.make, {
      element: Illustration.notAsked
    });
  }
  let tmp$1;
  let exit = 0;
  if (typeof status !== "object" && status === "Error") {
    tmp$1 = JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Button.make, {
          label: I18n.t("Reload the page"),
          tone: {
            NAME: "neutral",
            VAL: {
              quiet: false
            }
          },
          size: "small",
          icon: "refresh_v1",
          onPress: () => {
            window.location.reload();
          }
        }),
        spaceTop: "xsmall"
      }),
      align: "center"
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp$1 = JsxRuntime.jsx(TextStyle.make, {
      children: customText !== undefined ? customText : I18n.t(statusToText(status).text),
      align: "center",
      variation: "normal",
      size: compact ? "small" : "normal"
    });
  }
  let tmp$2;
  tmp$2 = typeof status !== "object" || childComponent === undefined ? null : JsxRuntime.jsx(Box.make, {
    children: childComponent(),
    spaceTop: compact ? "small" : "large",
    spaceBottom: compact ? "large" : "xxlarge"
  });
  newrecord$1.children = [JsxRuntime.jsx(Box.make, {
    children: tmp,
    spaceY: compact ? "xsmall" : "small",
    style: Primitive_option.some(illustrationStyle(compact))
  }), JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Title.make, {
        children: I18n.t(statusToText(status).title),
        level: compact ? 3 : 2,
        align: "center",
        weight: "medium"
      }),
      spaceTop: compact ? "none" : "xsmall",
      spaceBottom: compact ? "xxsmall" : "xsmall"
    }), tmp$1, tmp$2]
  })];
  newrecord.children = JsxRuntime.jsxs("div", newrecord$1);
  return JsxRuntime.jsx("div", newrecord);
}
let make = React.memo(Placeholder);
export { NA, NC, Empty, make };
/* text Not a pure module */